import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { MOBILE_CONFIG_CODE } from "src/api-setup/api-endpoints";

export const selectMobileConfigCode = async (cookiesData, dispatch) => {
  if (!cookiesData) return [];

  try {
    const apiHeaders = generateHeader();

    const requestBody = {
      pref_code: ["doc_dir", "allow_max_doc_size"],
    };

    const response = await POSTAPI(false, MOBILE_CONFIG_CODE, null, apiHeaders, requestBody, dispatch);

    if (response && response.data && response?.data?.out_parameters) {
      return response?.data?.out_parameters;
    }

    return [];
  } catch (error) {
    console.error(error);
    return [];
  }
};
